import auth0 from 'auth0-js';
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, HOME_PAGE } from "../constants";

const redirectUri = `${window.location.origin}${HOME_PAGE}`;

const webAuth = new auth0.WebAuth({
  domain: AUTH0_DOMAIN,
  clientID: AUTH0_CLIENT_ID,
  redirectUri: redirectUri,
  responseType: "token"
});

export default webAuth;



// WEBPACK FOOTER //
// ./src/auth/index.js